import { QueryClient } from "@tanstack/react-query";
import { Amplify } from "aws-amplify";
import mixpanel from "mixpanel-browser";
import React from "react";
import { Route } from "react-router-dom";

import { GraphQLAPI } from "@examspark/api";
import {
  AmplifyGraphQLClient,
  AnalyticsEventName,
  anonymousUserGUID,
  AppRoot,
  AppRoutes,
  getReactQueryClientParams,
  ProtectedRoutes,
  useAnalytics,
} from "@examspark/common-app";

import awsconfig from "./aws-exports";
import "./index.css";
import LoginRoutes from "./routes/login/LoginRoutes";
import PrivateRoutes from "./routes/PrivateRoutes";

mixpanel.init(process.env.REACT_APP_MIXPANEL_ID || "", {
  debug: process.env.REACT_APP_USER_BRANCH !== "master",
});

const CHATTY_REACT_QUERY = process.env.REACT_APP_CHATTY_REACT_QUERY;

Amplify.configure(awsconfig);
GraphQLAPI.config(AmplifyGraphQLClient);
const queryClient = new QueryClient(
  getReactQueryClientParams(!!CHATTY_REACT_QUERY),
);

/** Main root of the application.  */
const App = () => {
  const analytics = useAnalytics();

  React.useEffect(() => {
    analytics.trackEvent(AnalyticsEventName.ApplicationLaunchLegacy, {
      /** Avoid large mixpanel MTUs for students. */
      distinct_id: anonymousUserGUID,
      appName: "Go TCMPC",
      appWorkspaceId: "tx-tcmpc",
      appId: process.env.REACT_APP_EXAMSPARK_APP_ID,
    });
  }, [analytics]);

  return (
    <AppRoot
      awsconfig={awsconfig}
      queryClient={queryClient}
      codebaseName="bonfire"
    >
      <AppInner />
    </AppRoot>
  );
};

/** Take advantage of ContextProviders in the AppRoot. */
const AppInner = () => {
  return (
    <AppRoutes enableOidc>
      <Route
        path="/login/*"
        element={
          <LoginRoutes
            onLanguageChange={(value) => {
              //setLanguage(value)
            }}
          />
        }
      />
      <Route
        path="*"
        element={
          <ProtectedRoutes redirectOnLogin>
            <PrivateRoutes />
          </ProtectedRoutes>
        }
      />
    </AppRoutes>
  );
};

export default App;
